module.exports = __webpack_public_path__ + "static/media/review5.4d0a30d6.mp4";